// 单银行余额看板
<template>
  <div class="threeLevelMain">
      <div class="queryBox">
          <div class="query_row">
              <div class="scan_box">
                  <span class="sp_scan">当前银行：</span>
                  <el-select
                    size="mini"
                    v-model="queryForm.bank_name"
                    class="large_select"
                    @change="searchFunc"
                    >
                        <el-option 
                        v-for="b in $store.state.bankNameOptions"
                        :key="b.value"
                        :label="b.label" 
                        :value="b.value"
                        ></el-option>
                    </el-select>
              </div>
              <div class="scan_box">
                  <span class="sp_scan">日期：</span>
                  <el-date-picker
                    size="mini"
                    v-model="queryForm.time"
                    type="daterange"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    @change="searchFunc"
                    >
                    </el-date-picker>
              </div>
          </div>
          <div class="btn_area_out">
              <el-button size="mini" @click="resetQuery">重置查询</el-button>
              <el-button size="mini" @click="exportHandle">导出看板</el-button>
          </div>
      </div>
      <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :getDataConfig="dataQueryFunc()"
      :updateDataTag="updateDataTag"
      :orderNumConfig="{}"
      :totalCount="totalCount"
      >
      </tablePageComp>
  </div>
</template>

<script>
import api from '@/api'
import utils from '@/libs/utils.js'
export default {
 data() {
     return {
        dataList:[],
        updateDataTag:false,
        totalCount:0,// 数据总条数
        columnsList:[
            {
                label:"日期",
                prop:"time",
                width: 100
            },
            {
                label:"事务明细",
                prop: 'matter_details',
            },
            {
                label:"汇款名",
                prop:"remitter_name",
                width: 100
            },
            {
                label:"收入",
                prop:"revenue",
            },
            {
                label:"支出",
                prop:"expense",
            },
            {
                label:"当前银行余额",
                prop:"bank_name_money",
            },
            {
                label:"总余额",
                prop:"account_balance",
            },
            {
                label:"添加时间",
                prop:"add_time",
            },
        ],

        queryForm: {
            time: '',
            bank_name: this.$store.state.bankNameOptions[0].value
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
     }
 },
 methods: {
     exportHandle() {
        const loading = this.$loading({
            lock: true,
            text: '正在导出',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
        let paramObj = {
            bank_name: this.queryForm.bank_name
        }
        if(this.queryForm.time) {
            paramObj.time = this.queryForm.time.join(',')
        }
        
        api.exportSingleAccountBal(paramObj)
        .then(res => {
            // console.log(res)
            loading.close()
            utils.downloadFile(res)
        })
        .catch(error => {
            console.log(error)
            loading.close()
            this.$message.error('导出失败')
        })
     },
    resetQuery() {
        Object.keys(this.queryForm).forEach(key => this.queryForm[key] = '')
        this.queryForm.bank_name = this.$store.state.bankNameOptions[0].value
        this.updateDataTag = !this.updateDataTag
    },
     searchFunc() {
         utils.debounceFunc(function() {
             this.updateDataTag = !this.updateDataTag
         }.bind(this))
     },
     dataQueryFunc(){
        let paramObj = {}
        Object.keys(this.queryForm).forEach(key => {
            if(this.queryForm[key]) {
                paramObj[key] = this.queryForm[key]
            }
        })
            
        return {
            apiName:'getSingleBBList',
            paramObj:paramObj,
            success: function (response, callBack) {
                // console.log(response)
                let records = response.data.data.list
                let arr = []
                for (let i = 0; i < records.length; i++) {
                    let obj = records[i]
                    
                    Object.keys(obj).forEach(key => {
                        if(obj[key] == null || obj[key] == undefined) {
                            obj[key] = ''
                        }
                    })
                    
                    arr.push(obj)
                }
                this.dataList = arr
                this.totalCount = response.data.data.totalCount

                if (callBack) {
                    callBack()
                }
            }.bind(this),
            failed: function (error, callBack) {
                if (callBack) {
                    callBack()
                }
            }
        }
    },
 }
}
</script>

<style>

</style>